(function () {
    const init =  (viewport) => {
        const id = viewport.getAttribute('id');
        const targetLoader = viewport.querySelector('#'+id+'Loader');
        const container = viewport.querySelector('[data-image-zoom-viewport-container]');
        const targetImage = viewport.querySelector('#'+id+'ViewportImage');

        viewport.addEventListener('loadimage', (e) =>{
            container.classList.remove('loaded');
            targetLoader.dispatchEvent(new CustomEvent('show', {
                detail: {
                    src:e.detail.lowSrc,
                    width:e.detail.width,
                    height:e.detail.height
                }
            }));
            const img = new Image();
            img.onload = function () {
                setTimeout( () =>{
                    targetLoader.dispatchEvent(new CustomEvent('hide'));
                    container.classList.add('loaded');
                    targetImage.src = img.src;
                }, 100);
            };
            img.src = e.detail.src;
        });
        viewport.addEventListener('resize', (e) =>{
            targetImage.dispatchEvent(new CustomEvent('resize'));
        });
    };
    window.addEventListener('load',  ()=> {
        document.querySelectorAll('[data-image-zoom-viewport]').forEach((viewport) => {
            init(viewport);
        });
    });
})();
